import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import {
    loginRequested,
    clearErrorMessages,
    fbLoginRequested,
} from '../actions';
import { useLocation } from 'react-router';
import qs from 'query-string';
import {
    getLoginError,
    isUserLoggedIn,
    getLoginProgress,
    getActivePackgePrice,
    getActivePackge,
} from '../selectors';
import TextInput from '../../../common/TextInput/';
import CheckBox from '../../../common/CheckBox';
import { ROUTE_DASHBOARD } from '../../../navigation/constants';
import LoginBannerImage from '../../../icons/user-screen-banner.png';
import BrandLogo from '../../../icons/logo.svg';
import LoadingComponent from '../../../common/LoadingComponent';
import './styles.scss';
import {
    AVAILABLE_PACKAGES,
    LOGIN_USERNAME,
    LOGIN_PASSWORD,
} from '../constants';

function LoginPage({
    activePackageName,
    activePackagePrice,
    activePackageKey,
    onLogin,
    errorMessage,
    isLoggedIn,
    loginInProgress,
    clearErrorState,
}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);

    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);

        const localUsername = localStorage.getItem(LOGIN_USERNAME);
        const localPassword = localStorage.getItem(LOGIN_PASSWORD);
        if (localUsername || localPassword) {
            setUsername(localUsername ? localUsername : '');
            setPassword(localPassword ? localPassword : '');
            setRememberMe(true);
        }
    }, []);

    const location = useLocation();

    const queryParams = qs.parse(location.search);

    if (queryParams.package) {
        if (AVAILABLE_PACKAGES[queryParams.package.toUpperCase()]) {
            activePackageName =
                AVAILABLE_PACKAGES[queryParams.package.toUpperCase()].name;
            activePackagePrice =
                AVAILABLE_PACKAGES[queryParams.package.toUpperCase()].price;
            activePackageKey = queryParams.package.toUpperCase();
        }
    }

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={loginInProgress} />
        </div>
    );

    const buttonText = loginInProgress ? loader : 'Login';
    const isInviteLinkAvailable = localStorage.getItem('invite');
    // TODO should be done via persist blacklist
    useEffect(() => {
        clearErrorState();
    }, []);

    const onClickRememberMe = () => {
        if (rememberMe) {
            // if previously was true
            localStorage.setItem(LOGIN_USERNAME, '');
            localStorage.setItem(LOGIN_PASSWORD, '');
            setRememberMe(false);
        } else {
            // if previously was false
            localStorage.setItem(LOGIN_USERNAME, username);
            localStorage.setItem(LOGIN_PASSWORD, password);
            setRememberMe(true);
        }
    };
    return (
        <Fragment>
            {isLoggedIn ? (
                <Redirect
                    to={{
                        ...location,
                        pathname: ROUTE_DASHBOARD,
                    }}
                />
            ) : (
                <Fragment>
                    <section className="login-block">
                        <div className="container-fluid">
                            <div className="row">
                                <div
                                    className="col-md-8 banner-sec"
                                    style={
                                        {
                                            //background: `url(${LoginBannerImage}) no-repeat center center`,
                                        }
                                    }
                                >
                                    <img
                                        src={LoginBannerImage}
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="col-md-4 login-sec">
                                    <div className="logo d-flex justify-content-center">
                                        <img src={BrandLogo} alt="logo" />
                                    </div>
                                    {errorMessage && !loginInProgress ? (
                                        <p>{errorMessage}</p>
                                    ) : null}
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            onLogin(
                                                { username, password },
                                                activePackageName,
                                                activePackagePrice,
                                                activePackageKey,
                                            );
                                        }}
                                    >
                                        <div className="filter-form">
                                            <h2 className="mb-24 loginTitle">
                                                Sign In
                                            </h2>
                                            {/* <FacebookLogin
                                                appId={FB_APP_ID}
                                                fields={FB_RESPONSE_FIELDS}
                                                cssClass="btn btn-custom btn-block socialBtn-fb"
                                                icon="fa-facebook"
                                                callback={(response) => {
                                                    onFbLogin(
                                                        {
                                                            socialId:
                                                                response.id,
                                                            socialPlatform:
                                                                'FACEBOOK',
                                                        },
                                                        activePackageName,
                                                        activePackagePrice,
                                                        activePackageKey,
                                                    );
                                                }}
                                            />
                                            <div className="signin-seperator">
                                                <div className="signin-divider"></div>
                                                <div className="seperator-text">
                                                    OR
                                                </div>
                                                <div className="signin-divider"></div>
                                            </div> */}
                                            <div className="customInput">
                                                <h3 className="titleStyle2">
                                                    Email
                                                </h3>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text icon-profile-icon"></span>
                                                    </div>
                                                    <TextInput
                                                        type="text"
                                                        onChange={(event) => {
                                                            setUsername(
                                                                event.target
                                                                    .value,
                                                            );

                                                            if (rememberMe) {
                                                                localStorage.setItem(
                                                                    LOGIN_USERNAME,
                                                                    event.target
                                                                        .value,
                                                                );
                                                            }
                                                        }}
                                                        title="No empty spaces or special characters allowed"
                                                        value={username}
                                                        placeholder={'username'}
                                                        required="required"
                                                    />
                                                </div>
                                            </div>
                                            <div className="customInput">
                                                <h3 className="titleStyle2">
                                                    Password
                                                </h3>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text icon2-open"></span>
                                                    </div>
                                                    <TextInput
                                                        type="password"
                                                        onChange={(event) => {
                                                            setPassword(
                                                                event.target
                                                                    .value,
                                                            );

                                                            if (rememberMe) {
                                                                localStorage.setItem(
                                                                    LOGIN_PASSWORD,
                                                                    event.target
                                                                        .value,
                                                                );
                                                            }
                                                        }}
                                                        value={password}
                                                        required="required"
                                                        placeholder={'password'}
                                                    />
                                                </div>
                                            </div>
                                            <div className="customInput pt-0 mb-3">
                                                <div className="row">
                                                    <div className="col-6">
                                                        {/*<div className="custom-control mb-0 custom-checkbox d-none">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="customCheck1"
                                                            />
                                                        </div>*/}
                                                        <CheckBox
                                                            label="Remember Me"
                                                            id="remember-me"
                                                            onClick={
                                                                onClickRememberMe
                                                            }
                                                            selected={
                                                                rememberMe
                                                            }
                                                            isBold={true}
                                                            cursorAllowed={true}
                                                            disabled={false}
                                                        />
                                                    </div>
                                                    <div className="col-6 text-right">
                                                        <Link to="/reset-password">
                                                            <strong className="text-primary">
                                                                Forgot Password?
                                                            </strong>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-custom btn-block"
                                            >
                                                {buttonText}
                                            </button>
                                        </div>
                                    </form>
                                    {isInviteLinkAvailable && (
                                        <div className="col-12 text-center margin-top-24">
                                            Don&#39;t have an account?{' '}
                                            <Link to="/sign-up">
                                                <strong className="text-primary">
                                                    Sign up
                                                </strong>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer>
                        <p className="copyrights-signup text-center">
                            &copy; Copyright {new Date().getFullYear()}{' '}
                            Litterati
                        </p>
                    </footer>
                </Fragment>
            )}
        </Fragment>
    );
}

LoginPage.propTypes = {
    // function to be called when form is submitted
    onLogin: PropTypes.func.isRequired,

    // error message to be shown when something goes wrong with login request
    errorMessage: PropTypes.string,

    // Defining package name statically
    activePackageName: PropTypes.string,

    // Key associated to a package, required to be sent at the backend
    activePackageKey: PropTypes.string,

    // Defining package price statically
    activePackagePrice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),

    // indicates whether user is logged in or not
    isLoggedIn: PropTypes.bool,

    // whether login has been requested
    loginInProgress: PropTypes.bool,

    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,

    // function to be called when login with facebook is called
    onFbLogin: PropTypes.func.isRequired,
};

LoginPage.defaultProps = {
    errorMessage: null,
    activePackageName: AVAILABLE_PACKAGES['LBUSINESS'].name,
    activePackagePrice: AVAILABLE_PACKAGES['LBUSINESS'].price,
    activePackageKey: 'LBUSINESS',
    isLoggedIn: false,
    loginInProgress: false,
};

const mapStateToProps = (state) => {
    return {
        errorMessage: getLoginError(state),
        isLoggedIn: isUserLoggedIn(state),
        loginInProgress: getLoginProgress(state),
        packageName: getActivePackge(state),
        packagePrice: getActivePackgePrice(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogin: (
            userCreds,
            activePackageName,
            activePackagePrice,
            activePackageKey,
        ) =>
            dispatch(
                loginRequested(
                    userCreds,
                    activePackageName,
                    activePackagePrice,
                    activePackageKey,
                ),
            ),
        clearErrorState: () => dispatch(clearErrorMessages()),
        onFbLogin: (
            userCreds,
            activePackageName,
            activePackagePrice,
            activePackageKey,
        ) =>
            dispatch(
                fbLoginRequested(
                    userCreds,
                    activePackageName,
                    activePackagePrice,
                    activePackageKey,
                ),
            ),
    };
};

const ConnectedLoginPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginPage);

export default ConnectedLoginPage;
